export default import.meta.ROLLDOWN_FILE_URL("assets/alpharunLogomarkBlack-BuhF99HB.svg")